import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";
import {actionCreators} from "../store/Breadcrumbs";

class BreadcrumbMenu extends Component{
  constructor(props) {
    super(props);
    
    this.popHistory = this.popHistory.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }
  
  popHistory(event) {
    const key = event.target.parentNode.id;
    this.props.popHistory(key);
  }

  handleBack(){
    const breadcrumbs = this.props.breadcrumbs;
    this.props.popHistory(breadcrumbs.length - 2);
  }
  
  render(){
    return(
      <div>
        <div className="breadcrumb-menu">
          {this.props.breadcrumbs.map((breadcrumb, i) => {
            return (
              <div style={{display: 'flex', cursor: 'pointer'}} id={i} key={breadcrumb.key} onClick={this.popHistory}>
                <a className="breadcrumb" key={breadcrumb.key}>{breadcrumb.label}</a>
                {i !== this.props.breadcrumbs.length - 1 ? <span className="breadcrumb-icon"/> : '' }
              </div>
            )
          })}
        </div>
        <div className="back-button"  onClick={this.handleBack}>
          <span className="arrow-icon-blue"/><h4 id="light-blue">Back</h4>
        </div>
      </div>
    );
  }
}

BreadcrumbMenu.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
  router: PropTypes.object.isRequired,
  popHistory: PropTypes.func.isRequired
};

const mapStateToProps = function(state) {
  return {
    breadcrumbs: state.breadcrumbs.breadcrumbs,
    router: state.router    
  }
};

export default connect(mapStateToProps, 
    dispatch => bindActionCreators(actionCreators, dispatch))(BreadcrumbMenu);
